var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#F6B119",
    fill: "#FFF",
    cx: 16,
    cy: 16,
    r: 15.5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.07 8.632V12a.63.63 0 0 0 .628.632.63.63 0 0 0 .628-.632V8.632A.63.63 0 0 0 22.698 8a.63.63 0 0 0-.628.632z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.023 10.947h3.35a.63.63 0 0 0 .627-.631.63.63 0 0 0-.628-.632h-3.349a.63.63 0 0 0-.628.632.63.63 0 0 0 .628.631z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.674 8.421h-4.087c-.555 0-1.062.316-1.31.814l-.793 1.596a.21.21 0 0 1-.187.116H9.302A2.309 2.309 0 0 0 7 13.263v8.421c0 .614.243 1.204.674 1.638A2.3 2.3 0 0 0 9.302 24h13.396a2.3 2.3 0 0 0 1.628-.678A2.327 2.327 0 0 0 25 21.684v-7.158a.63.63 0 0 0-.628-.631.63.63 0 0 0-.628.631v7.158a1.045 1.045 0 0 1-1.047 1.053H9.303a1.045 1.045 0 0 1-1.046-1.053v-8.42a1.05 1.05 0 0 1 1.046-1.053h1.995c.555 0 1.062-.316 1.31-.815L13.4 9.8a.21.21 0 0 1 .187-.116h4.087a.63.63 0 0 0 .628-.631.63.63 0 0 0-.628-.632z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 13.053c-2.195 0-3.977 1.792-3.977 4s1.782 4 3.977 4 3.977-1.792 3.977-4-1.782-4-3.977-4zm0 1.263a2.73 2.73 0 0 1 2.72 2.737A2.73 2.73 0 0 1 16 19.789a2.73 2.73 0 0 1-2.72-2.736A2.73 2.73 0 0 1 16 14.316z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.d33a80590c7094c4bcda77df85346198.svg";
export { ForwardRef as ReactComponent };